import React from "react"
import types from "prop-types"
import { useCustomName } from "hooks"
import { useTaskFormContext } from "contexts/TaskFormContext"
/* eslint-disable-next-line max-len */
import TaskDepartmentList from "views/FormSubmission/FormSubmissionTabs/ActivitiesContent/TaskForms/TaskFields/UI/TaskDepartmentList"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import { departmentIdentifier } from "utils/taskHelpers"
import TaskAssigneeDepartmentSegments from "./TaskAssigneeDepartmentSegments"
import TaskDepartmentByIdLabel from "../UI/TaskDepartmentLabel/TaskDepartmentByIdLabel"

const TaskAssigneeDepartmentList = ({ className = "" }) => {
  const {
    addAssigneeDepartmentNotification,
    addAssigneeDepartmentNotificationOnComplete,
    removeAssigneeDepartment,
    removeAssigneeDepartmentNotification,
    removeAssigneeDepartmentNotificationOnComplete,
    taskAssigneeDepartments,
  } = useTaskFormContext()

  const { nameInSentence: departmentNameInSentence } = useCustomName(DEPARTMENT_KEY)

  if (taskAssigneeDepartments.length === 0) return null

  const toggleNotify = (dept) => () => {
    const toggleFunction = dept.notify ? removeAssigneeDepartmentNotification : addAssigneeDepartmentNotification
    toggleFunction(departmentIdentifier(dept))
  }

  const toggleNotifyOnComplete = (dept) => () => {
    const toggleFunction = dept.notifyOnComplete
      ? removeAssigneeDepartmentNotificationOnComplete
      : addAssigneeDepartmentNotificationOnComplete

    toggleFunction(departmentIdentifier(dept))
  }

  return (
    <div className={className}>
      <TaskDepartmentList
        className="mb-2"
        departments={taskAssigneeDepartments}
        removeDepartment={removeAssigneeDepartment}
        toggleNotify={toggleNotify}
        toggleNotifyOnComplete={toggleNotifyOnComplete}
        departmentLabelComponent={TaskDepartmentByIdLabel}
        segmentsComponent={TaskAssigneeDepartmentSegments}
        departmentDescriptor="assignee"
      />
      <p className="text-xs text-dark md:w-4/5">
        Each assignee {departmentNameInSentence} will have each of its members in the selected segments
        assigned to the task individually.  Each {departmentNameInSentence} member in the selected segments
        will also be granted individual access to the form submission and be made a member
        of any tasks selected under &quot;Access to Other Tasks&quot;.
      </p>
    </div>
  )
}

TaskAssigneeDepartmentList.propTypes = {
  className: types.string,
}

export default TaskAssigneeDepartmentList
